export const MONTH_LICENSES_DURATION = 1
export const YEAR_LICENSES_DURATION = 12
export const MIN_USERS_COUNT_FOR_ADD_USERS = 1
export const UNLIMITED_USERS_COUNT = -1
export const USERS_LIMITED_PACKAGES = [5, 10, 15, 20, 30, 40, 60, 80, 100, 150]
export const THROTTLE_TIME_WAIT = 800
export const BACK_OFFICE_PROCESS_STATUS_URL = window.__GENERATED_CONSTANTS__.BACK_OFFICE_PROCESS_STATUS_URL

export const PricingModelType = {
    PACKAGE: 'PACKAGE',
    USER: 'USER'
}

export const purchaseCardType = {
    RENEWAL: 'renewal',
    UPGRADE: 'upgrade',
}

export const CardBrandType = {
    MASTERCARD: 'Mastercard',
    VISA: 'Visa',
    AMERICAN_EXPRESS: 'American Express',
    OTHER: 'Unknown',
    NONE: 'None',
}

export const licensesType = {
    TRIAL: 'trial',
    COMMERCIAL: 'commercial',
    FREE: 'free',
}

export const purchaseStep = {
    COMPANY_INFO: 'companyInfo',
    ACCOUNT_INFO: 'accountInfo',
    PAYMENT: 'payment',
    SUCCESS: 'success',
    SWITCH_TO_FREE: 'switchToFree',
}

export const hostingZone = {
    NORTH_AMERICA: 'm',
    EUROPE: 'e',
}

export const contextCheckingStatus = {
    EMPTY: "empty",
    IN_PROGRESS: "inProgress",
    COMPLETED: "completed",
}

export const promoEditorMode = {
    APPLY: "apply",
    ENTER: "enter",
    REMOVE: "remove",
}

export const priceType = {
    PROMO_DISCOUNT: "promoDiscount",
    PAYMENT_METHOD_FEE: "paymentMethodFee",
    TAX: "tax",
    BASE_PRICE: "basePrice",
}

export const paymentMethod = {
    CC: 'CC',
    WIRE: 'WIRE',
    CHECK: 'CHECK',
}

export const purchaseStrategyType = {
    FIRST_PURCHASE: 'firstPurchase',
    FIRST_FREE: 'firstFree',
    PURCHASE: 'purchase',
    FREE: 'free',
    ADD_USERS: 'addUsers',
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/constants.js